// extracted by mini-css-extract-plugin
module.exports = {"inputWrap":"FormTextarea_inputWrap__tGLw_","input":"FormTextarea_input__FkTCc","root--error":"FormTextarea_root--error__ZdlZh","rotation":"FormTextarea_rotation__gxXcj"};